export default "__VITE_ASSET__f6gnC9y4__"